import { inject, injectable } from "inversify";
import { IEnquiryFormService } from "../interfaces/enquiryFormService";
import { ServiceResponse, CreateEnquiryDto, EnquiryDto, IPlatformClient, IPlatformClientId } from "@se/platform";

    
@injectable()
class EnquiryFormService implements IEnquiryFormService {

    constructor(
        @inject(IPlatformClientId) protected platformClient: IPlatformClient) {
    }

    public async SubmitEnquiryForm(dto: CreateEnquiryDto, accessToken: string): Promise<ServiceResponse<EnquiryDto>> {
        return await this.platformClient.forms.createEnquiry(dto, accessToken);
    }
};

export { EnquiryFormService }